/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Sigma = ["svg", defaultAttributes, [["path", { d: "M18 7V4H6l6 8-6 8h12v-3" }]]];

export { Sigma as default };
//# sourceMappingURL=sigma.js.map
